import { Trans } from 'react-i18next';

export const Pending = () => (
  <div className="bg-white flex flex-col  w-full h-full p-7 items-center py-6 justify-center sm:h-auto sm:w-96 sm:rounded-xl">
    <span className="text-lg font-medium mb-2 text-center">
      <Trans i18nKey="auth.review.title" />
    </span>
    <p className="text-base text-center">
      <Trans i18nKey="auth.review.message" />
    </p>
  </div>
);
